import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { ERROR_PROCESSING, LOAD_ERROR, PAGE_ERROR } from "./ErrorConstants";
import PageError from "./PageError";
import ErrorProcessingDialog from "./ErrorProcessingDialog";
import { IS_CANADA_MARKET } from "../utils/EmpUtil";
import { MARKET } from "../common/Constants";

function ErrorBoundary(props) {
  const [hasError, setHasError] = useState({});

  function closeErrorDialog() {
    const updatedError = {};
    updatedError[ERROR_PROCESSING] = false;
    setHasError(updatedError);
  }

  const market = sessionStorage.getItem(MARKET);

  if (hasError[PAGE_ERROR]) {
    return (
      <PageError
        close={closeErrorDialog}
        code={props.t("Error.404")}
        body={props.t("Error.pageError")}
      />
    );
  } else if (hasError[LOAD_ERROR]) {
    return (
      <PageError
        close={closeErrorDialog}
        code={null}
        body={props.t("Error.loadError")}
      />
    );
  } else if (hasError[ERROR_PROCESSING]) {
    return (
      <ErrorProcessingDialog
        open={true}
        close={closeErrorDialog}
        title={props.t("Error.processingErrorTitle")}
        body={
          IS_CANADA_MARKET(market)
            ? props.t("Error.processingErrorMessageCAN")
            : props.t("Error.processingErrorMessage")
        }
      />
    );
  }

  return props.children;
}

export default withTranslation("emp")(ErrorBoundary);
